
import { trackEvent as sendLogs } from '@airtel-web/clickstream';

import ENV from '../Environments';

import {
    isWeb,
    iosOrAndroid,
    getClickStreamPlatform,
    processMsisdn
} from './utility';

import {
    ClickStreamEventActions,
    ENVIRONMENT
} from "./constants";

import interceptor from "./interceptors";
import {
    analyticsUtil
} from './analyticsWrapper';


class ClickStreamWrapper {
    static hitNumber = 0;

    async sendClickStream(clickStreamModel) {
        try {
            clickStreamModel.msisdn = processMsisdn.getMsisdn();
            if (!isWeb()) {
                clickStreamModel.sessionId = await interceptor().getSessionId();
                clickStreamModel.visitorId = await interceptor().getVisitorId();
                clickStreamModel.appVersion = await interceptor().getAppVersion();
            }
            for (const key of Object.keys(clickStreamModel)) {
                try {
                    clickStreamModel[key] = clickStreamModel[key]?.toString().toLowerCase();
                }
                catch (ex) {
                    console.error(ex);
                }
            }
            clickStreamModel.platform = getClickStreamPlatform();
            clickStreamModel.os = iosOrAndroid().toLowerCase();
            clickStreamModel.navigationstartTs = (new Date()).getTime().toString();
            clickStreamModel.hitNumber = (ClickStreamWrapper.hitNumber++).toString();
            clickStreamModel.extraData1 = clickStreamModel.extraData1 || "";
            if (clickStreamModel.eventAction === ClickStreamEventActions.pageload) {
                clickStreamModel = { ...clickStreamModel, ...analyticsUtil(clickStreamModel.sessionId || "", "") };
            }
            sessionStorage.setItem("shopHitNumber", ClickStreamWrapper.hitNumber.toString());
            if (ENV.getEnvironment() === ENVIRONMENT.PROD) {
                sendLogs(clickStreamModel);
            } else {
                console.table(clickStreamModel);
                sendLogs(clickStreamModel);
            }
        }
        catch (err) {
            console.error(`Issue Analytics : ${err}`);
        }
    }

    dummyClickStream() {
        const clickStreamObj = {
            journey: "skyc",
            hitNumber: "1",
            eventCategory: "",
            section: "",
            subSection: "parentlane",
            eventAction: "click",
            eventLabel: "parentlane",
            eventValue: "hgt",
            customLabel: "crousel",
            isInteractive: "1",
            msisdn: "8800975904",
            horizontalPosition: "3",
            verticalPosition: "4",
        }
        sendLogs(clickStreamObj);
    }

    setClickStreamHitNumber(number) {
        ClickStreamWrapper.hitNumber = number;
    }

}


function clickStreamInstance() {
    return new ClickStreamWrapper();
}

export default clickStreamInstance;
